import GlobalHook from "use-global-hook";
import { CoT_MODE, DEAL_PRICE_WATCH_MODE, TARIFF_COMISSION } from "../settings/constants";

import * as actions from "./actions";
import { TESTDATA_HISTORY, TESTDATA_ORDERS } from "./testdata";

const initialState = {

  dummy: 1337,
  
  popup_opened: false,
  popup_settings_only_save: false,
  popup_deal_info: {

    id: "",
    name: "",
    type: "",
    result: "",
    movements: "",
    amount: "",
    comment: "",
    date_create: "",
    date_update: "",

  },

  user_name: "",

  user_tariff: {

    active: false,
    comment: "",
    duration: "",
    id: "",
    name: "",
    next_date: "",
    remaining: "",
    price: "",

  },

  currency: "",
  wanted_result_rub: 0,
  wanted_result_cny: 0,
  wanted_result_usd: 0,
  wanted_result_eur: 0,
  tariff_comission: TARIFF_COMISSION.TRADER,
  deal_price_watch_mode: DEAL_PRICE_WATCH_MODE.PRICE_OF_ONE_PAPER,
  comission_or_time: CoT_MODE.COMISSION,
  orders: [],
  history: [],

  token_tinkoff_extension: null,
  // orders: TESTDATA_ORDERS, ////[],
  // history: TESTDATA_HISTORY, ////[],

};

const useGlobal = GlobalHook( initialState, actions );

export default useGlobal;
